import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import Typography from "@mui/material/Typography";
import { Box, IconButton, ListItemIcon, Menu, MenuItem, Tooltip } from "@mui/material";
import { AccountInfo } from "@azure/msal-browser";
import { default as LogoutIcon } from "@mui/icons-material/Logout";
import { theme } from "../../Common/UI/styles/theme";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import CreateTicket from "../../Events/UI/CreateTicket";
import HelpCenterIcon from "@mui/icons-material/HelpCenter";
import useIsAdminAndViewOnly from "../../Common/UI/hooks/useIsAdminAndViewOnly";
import PersonIcon from "@mui/icons-material/Person";

const WelcomeName = () => {
  const { instance } = useMsal();
  const [name, setName] = useState("");
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [dialogOpen, setDialogOpen] = useState(false);

  const activeAccount: null | AccountInfo = instance.getActiveAccount();

  useEffect(() => {
    if ((activeAccount as AccountInfo) && !!activeAccount?.name) {
      setName(activeAccount?.name);
    } else {
      setName("");
    }
  }, [activeAccount]);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogoutClose = () => {
    setAnchorEl(null);
    instance.logoutRedirect();
  };

  const handleDialogOpen = () => {
    setDialogOpen(true);
  };

  const { isAdmin } = useIsAdminAndViewOnly();

  if (name) {
    return (
      <>
        {isAdmin ? (
          <Tooltip title="Create Ticket">
            <IconButton onClick={handleDialogOpen}>
              <ConfirmationNumberIcon htmlColor={theme.palette.primary.main} fontSize="large" />
            </IconButton>
          </Tooltip>
        ) : (
          <></>
        )}

        <Tooltip title="Help">
          <IconButton href="/help">
            <HelpCenterIcon htmlColor={theme.palette.primary.main} fontSize="large" />
          </IconButton>
        </Tooltip>

        <Tooltip title="Settings">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{
              borderRadius: "10px",
              p: "10px",
              pl: "15px",
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 32,
                height: 32,
                borderRadius: "50%",
                backgroundColor: "rgb(166, 25, 46)",
              }}
            >
              <PersonIcon htmlColor="white" />
            </Box>
            <Typography color="white" variant="h6">
              {name}
            </Typography>
          </IconButton>
        </Tooltip>

        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <MenuItem onClick={handleLogoutClose}>
            <ListItemIcon>
              <LogoutIcon fontSize="small" />
            </ListItemIcon>
            Logout
          </MenuItem>
        </Menu>

        {dialogOpen ? <CreateTicket dialogOpen={dialogOpen} setDialogOpen={setDialogOpen}></CreateTicket> : null}
      </>
    );
  } else {
    return null;
  }
};

export default WelcomeName;
